import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sort'
})
export class SortPipe implements PipeTransform {

  transform<T>(value: T[], propName: string, type: 'date' | 'asc' | 'desc' = 'asc', innerPropName?: string): T[] {
    if (!value || value.length === 0 || !propName) {
      return value;
    }

    let resultArray: T[] = [];

    if (type === 'date') {
      resultArray = [...value].sort((a, b) => {
        return innerPropName ?
          +new Date(b[propName][innerPropName]) - +new Date(a[propName][innerPropName]) :
          +new Date(b[propName]) - +new Date(a[propName]);
      });
    } else if (type === 'asc') {
      resultArray = [...value].sort((a, b) => {
        return innerPropName ?
          a[propName][innerPropName] - b[propName][innerPropName] :
          a[propName] - b[propName];
      });
    } else if (type === 'desc') {
      resultArray = [...value].sort((a, b) => {
        return innerPropName ?
          b[propName][innerPropName] - a[propName][innerPropName] :
          b[propName] - a[propName];
      });
    }

    return resultArray;
  }

}
